'use strict';

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/globalthis/implementation.js
// module id = 957
// module chunks = 231608221292675